import { TOPIC_GATE_CHANGE_AUDIENCE } from "@digital-twins/shared-types";

/**
 * What a decision-card click should do.
 *
 * Most picks are ordinary planner turns: the option's `value` is sent as the
 * user's message. The topic gate's "No" is different — it opens the audience
 * picker locally and never reaches the planner.
 */
export type DecisionCardAction =
  | { kind: "change_audience" }
  | { kind: "planner_turn"; value: string };

/**
 * Resolve a decision-card selection.
 *
 * The sentinel is honoured ONLY when the active card actually offered it.
 * The same handler receives free text from the "Other" box, so without that
 * check a message that merely looks like the sentinel would silently open the
 * audience picker on an unrelated card instead of being sent.
 */
export function resolveDecisionCardAction(
  value: string,
  activeOptionValues: ReadonlyArray<string>,
): DecisionCardAction {
  if (
    value === TOPIC_GATE_CHANGE_AUDIENCE &&
    activeOptionValues.includes(TOPIC_GATE_CHANGE_AUDIENCE)
  ) {
    return { kind: "change_audience" };
  }
  return { kind: "planner_turn", value };
}
